import { useState } from "react";
import { faqs } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-8 lg:gap-12">
          <div>
            <SectionHeading
              kicker="FAQ 常见问题"
              title="你可能想问的"
              desc="关于图集更新、查找方式与投稿使用的说明都在这里。没有找到答案，也欢迎直接联系我们。"
            />
            <div className="mt-6 p-5 rounded-xl bg-accent-500 text-background-50">
              <p className="font-heading font-bold text-lg">还没有解决问题？</p>
              <p className="mt-1 text-sm text-background-50/90">我们的图集编辑会尽快回复你的疑问。</p>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="mt-4 inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line"></i> 联系编辑
              </a>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={i}
                  className={`rounded-lg border bg-background-50 transition ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 flex items-center gap-3">
                      <span
                        className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                        }`}
                      >
                        Q
                      </span>
                      {f.q}
                    </h3>
                    <i
                      className={`ri-arrow-down-s-line text-xl shrink-0 transition-transform ${
                        open ? "rotate-180 text-primary-600" : "text-foreground-400"
                      }`}
                    ></i>
                  </button>
                  {open && (
                    <div className="px-4 md:px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}